import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getSifUnits(companyId) {
  try {
    const { data } = await authHttp().get(routes.urlCompanySifUnits(companyId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveSifUnit(payload) {
  try {
    const { company_id } = payload
    const { data } = await authHttp().post(routes.urlPostCompanySifUnit(company_id), payload)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getSifUnitsActived(companyId) {
  try {
    const { data } = await authHttp().get(routes.urlCompanySifUnitsActived(companyId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
